
import Vue from "vue";
import Alerter from "@/components/Alerter.vue";
import { OrganizationSchema, OrganizationsService } from "@/commons/client";
import { Alert } from "@/commons/types";

type Filters = {
  name: string;
  email: string;
  vat: string;
  phone: string;
  country: string;
  createdAfter: string | null; // <-- meglio nullabile
};

export default Vue.extend({
  name: "OrganizationListView",

  components: {
    Alerter,
  },

  data: () => ({
    searchKey: "",
    alerts: [] as Alert[],
    organizations: [] as OrganizationSchema[],
    loading: false,
    menu: false,
    advancedFiltersOpen: null as number | null,
    filters: {
      name: "",
      email: "",
      vat: "",
      phone: "",
      country: "",
      createdAfter: null as string | null,
    } as Filters,
  }),

  methods: {
    async quickSearch() {
      this.loading = true;

      try {
        this.organizations =
          await OrganizationsService.organizationListV1OrganizationsGet(
            undefined,
            100,
            this.searchKey,
            undefined
          );
      } catch (err) {
        this.alerts.push({
          type: "error",
          text: "Errore nella ricerca veloce",
        });
      }

      this.loading = false;
    },

    toggleAdvancedFilters() {
      this.advancedFiltersOpen = this.advancedFiltersOpen === 0 ? null : 0;
    },

    async applyFilters() {
      this.loading = true;
      try {
        const all =
          await OrganizationsService.organizationListV1OrganizationsGet(
            0,
            100,
            this.searchKey,
            undefined
          );

        this.organizations = all.filter((org) => {
          const matchesVat = this.filters.vat
            ? org.vat?.toLowerCase().includes(this.filters.vat.toLowerCase())
            : true;

          const matchesPhone = this.filters.phone
            ? org.phone_number
                ?.toLowerCase()
                .includes(this.filters.phone.toLowerCase())
            : true;

          const matchesCountry = this.filters.country
            ? org.country?.toLowerCase() === this.filters.country.toLowerCase()
            : true;

          // 🔒 Narrowing sicuro per le date
          const createdAfterDate = this.filters.createdAfter
            ? new Date(this.filters.createdAfter)
            : null;

          const orgCreatedDate = org.created ? new Date(org.created) : null;

          const matchesCreated = createdAfterDate
            ? !!orgCreatedDate && orgCreatedDate >= createdAfterDate
            : true;

          return matchesVat && matchesPhone && matchesCountry && matchesCreated;
        });
      } catch (err) {
        this.alerts.push({
          type: "error",
          text: "Errore durante il filtro avanzato",
        });
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = {
        name: "",
        email: "",
        vat: "",
        phone: "",
        country: "",
        createdAfter: null, // <-- reset coerente
      };
      this.applyFilters();
    },

    async getOrganizations(search = ""): Promise<OrganizationSchema[]> {
      try {
        this.loading = true;
        return await OrganizationsService.organizationListV1OrganizationsGet(
          undefined,
          undefined,
          search
        );
      } catch (err) {
        this.alerts.push({
          type: "error",
          text: "Errore nel recupero delle aziende",
        });
        return [];
      } finally {
        this.loading = false;
      }
    },

    async search(): Promise<void> {
      this.organizations = await this.getOrganizations(this.searchKey);
    },

    formatDate(dateStr?: string): string {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("it-IT");
    },
  },

  computed: {
    countryOptions(): Array<{ text: string; value: string }> {
      return this.$store.state.countries.map((c: any) => ({
        text: c.display_name,
        value: c.value,
      }));
    },
  },

  async mounted() {
    this.organizations = await this.getOrganizations();
  },
});
